<template>
  <div class="bg-white rounded-lg border border-gray-200 shadow-sm">
    <div class="px-4 py-3 border-b border-gray-200">
      <div class="flex justify-between items-center">
        <h2 class="heading-section">Call Configurations</h2>
        <button @click="openConfigModal(null)" class="btn-primary-sm">
          <font-awesome-icon icon="plus" />
          New Configuration
        </button>
      </div>
    </div>
    <div>
      <ag-grid-vue
        style="width: 100%; height: 100%"
        :theme="theme"
        :columnDefs="columnDefs"
        :rowData="configurations"
        :defaultColDef="defaultColDef"
        :grid-options="{ domLayout: 'autoHeight', context: { componentParent: this }, suppressCellFocus: true }"
        @row-clicked="$emit('open-config-modal', $event.data.id)"
      />
    </div>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue3'
import CellStatusBadge from '@/components/Outreach/Cells/CellStatusBadge.vue'
import CellButton from '@/components/Outreach/Cells/CellButton.vue'
import { formatRelativeTime } from '@/utils/date'
import { formatLabel } from '@/utils/string'
import { standardListTheme } from '@/utils/common'

export default {
  name: 'CallConfigurationsCard',
  components: {
    AgGridVue,
    CellStatusBadge,
    CellButton,
  },
  props: {
    configurations: {
      type: Array,
      required: true,
    },
  },
  emits: ['configurations-updated', 'open-config-modal'],
  data() {
    return {
      theme: standardListTheme,
      defaultColDef: {
        flex: 1,
        minWidth: 100,
        resizable: true,
        sortable: true,
        filter: true,
      },
      columnDefs: [
        { field: 'name', headerName: 'Name' },
        {
          field: 'entry_agent_name',
          headerName: 'Entry Agent',
          valueGetter: (params) => params.data.entry_agent_name || '-'
        },
        {
          field: 'voice',
          headerName: 'Voice',
          valueGetter: (params) => formatLabel(String(params.data.voice || ''))
        },
        {
          field: 'use_external_tts',
          headerName: 'Audio AI',
          valueGetter: (params) => params.data.use_external_tts ? 'Cartesia' : 'OpenAI',
          cellRenderer: CellStatusBadge,
          cellRendererParams: {
            variant: 'tts-provider',
          },
        },
        {
          field: 'status',
          headerName: 'Status',
          valueGetter: (params) => formatLabel(String(params.data.status || '')),
          cellRenderer: CellStatusBadge,
          cellRendererParams: {
            variant: 'call-config'
          },
          filter: 'agSetColumnFilter',
        },
        {
          field: 'updated_at',
          headerName: 'Updated',
          valueGetter: (params) => {
            return params.data.updated_at ? new Date(String(params.data.updated_at)) : null
          },
          valueFormatter: (params) => {
            return params.data.updated_at ? formatRelativeTime(String(params.data.updated_at)) : '-'
          },
          filter: 'agDateColumnFilter',
        },
        {
          field: 'actions',
          headerName: 'Actions',
          cellRenderer: CellButton,
          cellRendererParams: (params) => ({
            icon: 'pen-to-square',
            onClick: (data) => params.context.componentParent.openConfigModal(data.id)
          }),
          sortable: false,
          filter: false,
        },
      ],
    }
  },
  methods: {
    openConfigModal(configId) {
      this.$emit('open-config-modal', configId)
    },
  },
}
</script>
